import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";

/**
 * passare una lista di ruoli con il path della home da gestire come in esempio
 * [{role:"11",path:"/dashboard"},...]
*/

function Redirector({roleHomes=[]}) {
  const token = useSelector((state)=>state.user.token);
  const role = useSelector((state)=>state.user.role);
  const home = roleHomes.find((config)=>config.role === role);

  if (!token){
    return <Navigate to="/login" replace />;
  }else if(home){
    return <Navigate to={home?.path} replace />;
  }
  return <Navigate to="/login" replace />;
}

export default Redirector;